var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23.9678,
    r: 23,
    fill: "#E1EBF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.48 17.8478L22.6 14.9678L19.72 17.8478M28.36 19.7678H32.2V32.2478H13V19.7678H16.84H28.36ZM22.6 21.6878V14.9678V21.6878Z",
    stroke: "#115BC7",
    strokeWidth: 1.22667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.9678L22.5 28.9678L32 20.9678",
    stroke: "#115BC7",
    strokeWidth: 1.02222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.4f2229bd1ce2660582dd0084c1706631.svg";
export { ForwardRef as ReactComponent };